/**
 * Website URL utility functions
 * 
 * Centralizes website URL handling from REACT_APP_WEBSITE_BASE_URL environment variable
 * with a default fallback value.
 */

const DEFAULT_WEBSITE_BASE_URL = 'https://mindfultherapygroup.com';

/**
 * Gets the website base URL from environment variable or returns the default
 * @returns Website base URL (e.g., "https://mindfultherapygroup.com")
 */
export function getWebsiteBaseUrl(): string {
  return process.env.REACT_APP_WEBSITE_BASE_URL || DEFAULT_WEBSITE_BASE_URL;
}

/**
 * Builds a full URL for a specific path on the website
 * @param path - Path to append (e.g., "/find-a-provider/" or "get-started-2/")
 * @returns Complete URL (e.g., "https://mindfultherapygroup.com/find-a-provider/")
 */
export function buildWebsiteUrl(path: string): string {
  const baseUrl = getWebsiteBaseUrl();
  // Ensure base URL doesn't end with slash
  const cleanBase = baseUrl.replace(/\/$/, '');
  // Ensure path starts with slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
}

/**
 * Gets the find-a-provider URL with query parameters
 * @param stateString - Optional state string to include in query params
 * @returns Complete find-a-provider URL with query parameters
 */
export function getFindProviderUrl(stateString?: string | null): string {
  const baseUrl = buildWebsiteUrl('/find-a-provider/');
  const stateParam = stateString ? `?providerState=${encodeURIComponent(stateString)}` : '';
  return `${baseUrl}${stateParam}&providerWashingtonService=&availableDay_1=&availableTime_1=&availableDay_2=&availableTime_2=&availableDay_3=&availableTime_3=&providerWashingtonAgeRange=`;
}

/**
 * Gets the get-started URL
 * @returns Complete get-started URL
 */
export function getGetStartedUrl(): string {
  return buildWebsiteUrl('/get-started-2/');
}

